import React from 'react';
import { AsyncComponent } from '@twigeducation/async-component';
import AsyncComponentError from '../Error/AsyncComponentError';

const QuizProvider = props => (
    <AsyncComponent
        appName="twig-games"
        componentName="TwigGames"
        errorComponent={AsyncComponentError}
        providerType="QUIZ"
        {...props}
    />
);

export default QuizProvider;
